import type { Project } from '../types/content'

export const projects: Project[] = [
  {
    slug: 'cadets',
    title: 'Cadets',
    client: 'Cadets',
    year: '2026',
    location: '6 cities',
    discipline: 'Mobile Tour',
    summary:
      'A mobile retail pop-up across six cities, letting customers shop an online-only Dallas brand in person for the first time.',
    image: '',
    video:
      'https://www.dropbox.com/scl/fo/vqn0t65vsxkr7px0fcbym/ALJz8Y0vuRpQU96Vnz-ntTU/Videos/2026-4-17%20Cadet%20Pop%20Up%20Dallas%20Video%2016x9.mp4?rlkey=tqubewmw6ntro8zxd776hr2jd&raw=1',
    scope: [
      'Mobile retail build',
      'Routing & permitting',
      'Staffing',
      'On-site production',
    ],
    challenge:
      'Cadets had built its following entirely online out of Dallas. Customers could see the product but never touch it, and the brand had no way to meet its community in person.',
    approach:
      'We put the store on the road — a mobile retail pop-up routed through six cities, merchandised to shop exactly like the site, and staffed to turn a sidewalk crowd into a checkout line.',
    outcome:
      'Exponential exposure in every market and sales above expectation across the tour.',
  },
  {
    slug: 'hydrafacial-tradeshow',
    title: 'Tradeshow Booth',
    client: 'Hydrafacial',
    year: '2024',
    location: 'Las Vegas',
    discipline: 'Tradeshow',
    summary:
      'A tradeshow destination built to let guests explore, experience and talk — driving ROI by 850%.',
    image:
      'https://cdn.magicpatterns.com/uploads/8YneS9eg5NKSQLWMbR9A86/HydrafacailVegasTradeshow-KathyDeNinnoPhotography-378.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/1Kq6SJGjQgEe1uXPcrJGc2/HydrafacailVegasTradeshow-Details-KathyDeNinnoPhotography-77_(1).jpg',
      'https://cdn.magicpatterns.com/uploads/gKHpRUQmW93QEXAQCSwckf/HydrafacailVegasTradeshow-KathyDeNinnoPhotography-352.jpg',
      'https://cdn.magicpatterns.com/uploads/gXfa8eSZ8HgVpWqCbQjEmB/HydrafacailVegasTradeshow-Details-KathyDeNinnoPhotography-13.jpg',
      'https://cdn.magicpatterns.com/uploads/7ARYtwdiKkjjAwygGoqPFm/HydrafacailVegasTradeshow-Details-KathyDeNinnoPhotography-20.jpg',
    ],
    scope: [
      'Exhibit strategy & booth design',
      'Custom fabrication & scenic',
      'Product demonstrations',
      'On-site production & staffing',
    ],
    challenge:
      'Getting customers to see the value in an aesthetic device — and to feel the install glow and the treatment itself first hand, which is what they are really shopping for.',
    approach:
      'We built a destination rather than a booth: an open floor guests could explore, live treatment chairs so the result could be felt on the spot, and lit product moments that pulled the hall toward sales conversations.',
    outcome:
      'A booth that drove ROI by 850% and turned demonstrations into direct sales conversations.',
    stats: [{ label: 'ROI', value: '850%' }],
  },
  {
    slug: 'tonymoly-movie-night',
    title: 'Movie Night',
    client: 'TONYMOLY',
    year: '2026',
    location: 'Los Angeles',
    discipline: 'Influencer Event',
    summary:
      'An intimate Valentine’s Day screening that turned a classic movie night into a playful, shareable self-care moment.',
    image:
      'https://cdn.magicpatterns.com/uploads/sJaDnWx2PGanKGmER6gZuo/TonyMolyEvent-KathyDeNinnoPhotography-69.jpg',
    video:
      'https://cdn.magicpatterns.com/uploads/mL2ewvfEwvTv51KKsFMKkp/TonyMoly%20Video.mp4#t=7.5',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/s5ZwMPFqfkVXSqSEZFFFT9/TonyMolyEvent-KathyDeNinnoPhotography-49.jpg',
      'https://cdn.magicpatterns.com/uploads/oVDtiY9bd5QWK9m3YpyQeH/TonyMolyEvent-KathyDeNinnoPhotography-53.jpg',
      'https://cdn.magicpatterns.com/uploads/cmQemCethPdMXRAVMBkuLq/TonyMolyEvent-KathyDeNinnoPhotography-57.jpg',
      'https://cdn.magicpatterns.com/uploads/2UV8o3FuniDKfa54myL1F5/TonyMolyEvent-KathyDeNinnoPhotography-107.jpg',
      'https://cdn.magicpatterns.com/uploads/xgBgxzJLGAZgNWQ1dEowe3/TonyMolyEvent-KathyDeNinnoPhotography-126.jpg',
      'https://cdn.magicpatterns.com/uploads/qMantwJoW4pmNDoZBAZG2C/TonyMolyEvent-KathyDeNinnoPhotography-133.jpg',
    ],
    scope: [
      'Concept & creative direction',
      'Venue transformation',
      'Custom programming',
      'On-site production',
    ],
    challenge:
      'Bringing together a curated group of Los Angeles influencers for Valentine’s Day in a way that felt genuinely intimate rather than like a standard brand dinner.',
    approach:
      'We transformed a screening room for a showing of How to Lose a Guy in 10 Days. Guests were welcomed with TONYMOLY face masks, movie-night candy, specialty cocktails, and custom florals. A live poet created personalized “love letters to your skin” for guests to take home.',
    outcome:
      'The experience invited guests to mask, mingle, and create content while organically discovering TONYMOLY products in a relaxed, playful setting.',
  },
  {
    slug: 'wizard-wellness',
    title: 'Coachella',
    client: 'Wizard Wellness',
    year: '2026',
    location: 'Indio',
    discipline: 'Mobile Tour',
    summary:
      'A mobile experiential moment that brought a nasal spray brand to consumers on their way to Coachella.',
    image:
      'https://cdn.magicpatterns.com/uploads/aFMzauK4UNHrDf4DggPR7i/WizardWellness-CoachellaActivation-KathyDeNinnoPhotography-53.jpg',
    video:
      'https://cdn.magicpatterns.com/uploads/wKVcyNrGNJ76mjrQAKpHVJ/SnapInsta.to_AQMYDfY2DIVwyZf6QvIIN_GRqBGURWEx3WF1_dI2hwuUEnfgW1hFGpqCfMnQgxQY_3wZyvGMOtucCcumjVp5dNN4AEBMLhrCagz13xc.mp4',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/7CitR9EiKhD44y6KabavUm/WizardWellness-CoachellaActivation-KathyDeNinnoPhotography-60.jpg',
      'https://cdn.magicpatterns.com/uploads/g3jYcSXvAvYx5VfxPYZ3ca/WizardWellness-CoachellaActivation-KathyDeNinnoPhotography-69.jpg',
    ],
    scope: [
      'Mobile fabrication',
      'Influencer drops',
      'High-volume sampling',
      'Tour logistics',
    ],
    challenge:
      'Wizard Wellness needed to introduce its nasal spray to a festival audience, creating an unexpected and highly visible brand moment that could stop people in their tracks.',
    approach:
      'We anchored a mobile pop-up with a playful, custom-fabricated oversized nose. The activation combined personalized influencer drops the day before with bold branding and high-volume product sampling on the route to the festival.',
    outcome:
      'More than 3,000 samples were delivered directly into the hands of consumers heading into Coachella.',
    stats: [{ label: 'Samples delivered', value: '3,000+' }],
  },
  {
    slug: 'zo-skin-health',
    title: 'Tinted Sunscreen Launch',
    client: 'ZO Skin Health',
    year: '2026',
    location: 'Los Angeles',
    discipline: 'Influencer Event',
    summary:
      'A curated poolside experience designed to drive product discovery, trial, and sales for ZO Skin Health’s first-ever tinted sunscreen.',
    image:
      'https://cdn.magicpatterns.com/uploads/tnrLuBeUL5WuqyTkYPDd6P/ZOSkinHealth-06242026-231.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/tScyZuxSFHfdCZJ8rwACtd/ZOSkinHealth-06242026-7.jpg',
      'https://cdn.magicpatterns.com/uploads/tfNMnRGN8qodhHtYguGGoZ/ZOSkinHealth-06242026-91.jpg',
      'https://cdn.magicpatterns.com/uploads/sBePUDT9gqLVez3KFPSfD1/ZOSkinHealth-06242026-89.jpg',
      'https://cdn.magicpatterns.com/uploads/nAYRLM6YAfnzaZjTpXgixV/ZOSkinHealth-06242026-43.jpg',
      'https://cdn.magicpatterns.com/uploads/8U23t3YoiKnNMQcXynJJt4/ZOSkinHealth-06242026-33.jpg',
      'https://cdn.magicpatterns.com/uploads/akKViYVdbWH1nikErdciuZ/ZOSkinHealth-06242026-30.jpg',
      'https://cdn.magicpatterns.com/uploads/nanwvyKZC1YFq8rquJgptU/ZOSkinHealth-06242026-29.jpg',
    ],
    scope: [
      'Event concept & design',
      'Custom fabrication',
      'Product trial stations',
      'On-site production',
    ],
    challenge:
      'Launching ZO Skin Health’s first-ever tinted sunscreen required an environment that encouraged immediate trial and shade matching while feeling like an exclusive summer event.',
    approach:
      'We created a curated poolside experience where KOLs, influencers, and consumers moved through personalized shade matching, a custom keychain bar, elevated branded moments, and poolside DJ sets.',
    outcome:
      'The experience brought the product to life in a social, summer-forward setting, creating meaningful opportunities for trial and purchase that ultimately helped drive the new launch to sell out.',
    stats: [{ label: 'Launch status', value: 'Sold out' }],
  },
  {
    slug: 'western-sons-vodka-tour',
    title: 'Western Sons Vodka Tour',
    client: 'Western Sons Vodka',
    year: '2026',
    location: 'Dallas & Austin, TX',
    discipline: 'Mobile Tour',
    summary:
      'A metroplex pop-up sampling signature cocktails, driving awareness and sales through a targeted bounce-back strategy.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0c9ee64c-e559-4a28-bc40-03d3a28d8418.jpg',
    video:
      'https://cdn.magicpatterns.com/uploads/r8TgN2EzStB9XYdvMSDaEJ/Western%20Sons%20Video.mp4',
    scope: [
      'Mobile tour routing',
      'Custom vehicle fabrication',
      'High-volume sampling',
      'Culinary & custom cocktails',
      'Brand ambassadors',
    ],
    challenge:
      'Western Sons Vodka wanted to increase brand awareness and drive sales in the highly competitive Texas metroplex markets of Dallas and Austin.',
    approach:
      'We designed a mobile pop-up tour that traveled throughout the metroplex, intercepting consumers and sampling signature cocktails made with Western Sons Vodka.',
    outcome:
      'The tour passed out more than 2,000 sampled drinks. By utilizing a strategic website bounce-back, the activation successfully drove a 78% increase in sales awareness.',
    stats: [
      { label: 'Samples distributed', value: '2,000+' },
      { label: 'Sales awareness', value: '+78%' },
    ],
  },
  {
    slug: 'jergens-lets-glow-girls',
    title: 'Let’s Glow Girls',
    client: 'Jergens',
    year: '2025',
    location: 'Austin, TX',
    discipline: 'Activation',
    summary:
      'A playful one-day college activation designed to drive product discovery and trial while creating a highly shareable moment on campus.',
    image:
      'https://cdn.magicpatterns.com/uploads/wEaZouzEhZJngZmeqmW1u7/Jergens_ATX.jpg',
    gallery: [
      'https://cdn.magicpatterns.com/uploads/bVkQUvjkrfhheWDEipD7af/Jergens.jpg',
      'https://cdn.magicpatterns.com/uploads/sPBSMyeehq4xszwwX4XFnU/Jergens_2.jpg',
      'https://cdn.magicpatterns.com/uploads/msozRNM9K6mYdb9JRso82w/TM0A2147.jpg',
      'https://cdn.magicpatterns.com/uploads/te1gznuVnuuf6srGH5Cvg4/Jergens.jpg',
      'https://cdn.magicpatterns.com/uploads/1x42pvTvu1TmcVF4LXUrvw/Jergens_6.jpg',
      'https://cdn.magicpatterns.com/uploads/swX3VHgTWxkkaUTvihpUYi/Jergens_5.jpg',
      'https://cdn.magicpatterns.com/uploads/j7xn172tKETp9916shLWSR/Jergens_4.jpg',
    ],
    scope: [
      'Concept & creative direction',
      'Custom fabrication',
      'High-volume sampling',
      'On-site production',
    ],
    challenge:
      'Jergens needed to introduce its Instant Sun Express Self Tanner to a college audience, driving product discovery and trial through a fun, consumer-first experience.',
    approach:
      'We brought the glow to Austin with a playful “Let’s Glow Girls” experience. Students moved through interactive stations, received product samples and giveaways, and picked up custom branded swag.',
    outcome:
      'The activation successfully brought Jergens’ sunless glow to life, creating a highly shareable moment on campus and getting the product directly into the hands of the target demographic.',
  },
  {
    slug: 'netflix-little-house',
    title: 'Little House on the Prairie',
    client: 'Netflix',
    year: '2026',
    location: '3 cities',
    discipline: 'Mobile Tour',
    summary:
      'A synchronized experiential pop-up bringing the campaign to life across Los Angeles, Dallas, and Philadelphia in a single weekend.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0c9ee64c-e559-4a28-bc40-03d3a28d8418.jpg',
    video:
      'https://cdn.magicpatterns.com/uploads/t5YhuyspZCwML6wRN4gmD4/30_sec_v2-2_15MB.mp4',
    scope: [
      'Multi-city logistics',
      'Custom fabrication',
      'Brand installations',
      'On-site production',
    ],
    challenge:
      'Netflix needed to build awareness and drive tune-in for Little House on the Prairie across multiple major markets simultaneously, engaging consumers in an unexpected way.',
    approach:
      'We deployed identical custom-fabricated flower carts and branded installations across Los Angeles, Dallas, and Philadelphia on the exact same weekend. Guests received complimentary fresh flowers while discovering the series.',
    outcome:
      'Turned a simple giveaway into a memorable brand interaction that built awareness, sparked social sharing, and drove tune-in across all three markets.',
  },
  {
    slug: 'hydrafacial-glowvolution',
    title: 'GLOWvolution',
    client: 'Hydrafacial',
    year: '2024',
    location: 'New York & Los Angeles',
    discipline: 'Activation',
    summary:
      'Immersive house takeovers transforming spaces into three-day wellness retreats centered around glowing from the inside out.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0c9ee64c-e559-4a28-bc40-03d3a28d8418.jpg',
    video:
      'https://cdn.magicpatterns.com/uploads/kmjdqLDZB9qse24STmXhWi/GlowVolution_VENUE_15MB.mp4#t=5.5',
    scope: [
      'Venue transformation',
      'Custom programming',
      'Brand partnerships',
      'On-site production',
    ],
    challenge:
      'Hydrafacial wanted to create an elevated environment for influencers, press, consumers, and providers to experience the brand, discover treatments, connect, and recharge.',
    approach:
      'We executed immersive house takeovers in New York and Los Angeles, blending skincare, wellness, and personalization through customized treatments, a personalization bar, IV therapy, yoga classes, and permanent jewelry.',
    outcome:
      'Every touchpoint was thoughtfully designed to immerse guests in the GLOWvolution lifestyle, creating a comprehensive wellness retreat experience.',
  },

]

export function getProject(slug: string): Project | undefined {
  return projects.find((project) => project.slug === slug)
}
